<template>
	<div class="h-100">
		
		<div class="d-flex scrip-detail  listProperty h-auto">
			<div class="first-wishlist fullHeight">
				<app-watchlist :loadChart="loadChart" :mn="mn" v-model="chartKeys"></app-watchlist>
			</div>
			<div class="act_web_dash calculateWidth">
				<div class="d-flex twoColmn-map">
					<div class="splitTop ">
						<!--Main Chart -->
						<div class="secondary-color head-breadcrum p-10 d-flex align-items-center justify-content-between">
							<div class="inLeft d-flex align-items-center">
								

								<router-link :to="{path:'/'}" style="color: white;"><feather class="mr-1" size="25px" type="arrow-left"></feather></router-link>

								<p class="m-0 f-14">{{loadChart}}</p>

								<div class="priceCalc d-flex flex-wrap" v-if="instruments[loadChart]">
									<span class="large">{{Number(instruments[loadChart].B).toFixed(contractSize.length-1)}}</span>
									<span class="prceFeed d-flex align-items-center" :class="[{'green font-weight-bold': (instruments[loadChart].B - instruments[loadChart].other.closepx) > 0,'red font-weight-bold': (instruments[loadChart].B - instruments[loadChart].other.closepx) < 0}]">
										<feather class="mr-1" size="15px" type="chevron-up" v-if="(instruments[loadChart].B - instruments[loadChart].other.closepx) > 0"></feather>
										<feather class="mr-1" size="15px" type="chevron-down" v-else-if="(instruments[loadChart].B - instruments[loadChart].other.closepx) < 0"></feather>
										({{parseFloat((((instruments[loadChart].B - instruments[loadChart].other.closepx)/instruments[loadChart].other.closepx)*100).toFixed(3))}}%)
									</span>
								</div>
							</div>
							<div class="inRight d-flex align-items-center">
								<ul class="wvu-breadcrumbs">
									<li><router-link :to="{path:'/'}">{{$t('market') }} </router-link></li>
									<li v-if="instruments[loadChart]"><a href="#">{{instruments[loadChart].other.type}}</a></li>
									<li><a href="#">{{loadChart}}</a></li>
								</ul>
							</div>
						</div>
						<!-- <app-chartsecssion :loadChart="loadChart" :mn="mn" v-model="chartKeys"></app-chartsecssion> -->
						<trading-view :loadChart="loadChart" :mn="mn" v-if="!showChart"></trading-view>
						<chart-iq :mn="mn" :loadChart="loadChart" v-else></chart-iq>
						<!--Main Chart Close-->
					</div>
					<div class="rangeOverview insmallScreen">
						<ul class="tabScript d-inline-flex align-items-center w-100 ml-10 border-bottom">
							<li :class="(scriptType == 'All')?'active':' '">
								<a @click="scriptType = 'All' " href="#">{{$t('all')}} </a>
							</li>
							<li :class="(scriptType == 'List Property')?'active':' '">
								<a @click="scriptType = 'List Property'" href="#">{{$t('list_property')}}</a>
							</li>
						</ul>
						<div class="content-tab scrollbar overView " v-if="scriptType == 'All'">
							<div class="secondary-color p-10 h-100">
								<div class="elementHistoy pl-0">
									<span class="buttonType">{{$t('overview')}}</span>
								</div>
								<ul class="d-flex justify-content-between align-items-center">
									<li class="ovr-with">
										<span class="sm">{{$t('open')}}</span>
										<p class="m-0 f-12">{{parseFloat(parseFloat(oneDayData.open || 0).toFixed(5)) || '-'}}</p>
									</li>
									<li class="ovr-with">
										<span class="sm">{{$t('day_low')}}</span>
										<p class="m-0 f-12">{{parseFloat(parseFloat(oneDayData.low || 0).toFixed(5)) || '-'}}</p>
									</li>
									<li class="ovr-with">
										<span class="sm">{{$t('close')}}</span>
										<p class="m-0 f-12">{{parseFloat(parseFloat(cugrrentClose() || 0).toFixed(5)) || '-'}}</p>
									</li>
								</ul>
								<ul class="d-flex justify-content-between align-items-center mt-3">
									<li class="ovr-with">
										<span class="sm">{{$t('prev_close')}}</span>
										<p class="m-0 f-12">{{parseFloat(parseFloat(lastClose() || 0).toFixed(5)) || '-'}}</p>
									</li>
									<li class="ovr-with">
										<span class="sm">{{$t('day_high')}}</span>
										<p class="m-0 f-12">{{parseFloat(parseFloat(oneDayData.high || 0).toFixed(5)) || '-'}}</p>
									</li>
									<li class="ovr-with">
										<span class="sm">{{$t('52_week_low')}}</span>
										<p class="m-0 f-12">{{parseFloat(parseFloat(prevYearData.low || 0).toFixed(5)) || '-'}}</p>
									</li>
								</ul>
							</div>
							<div class="secondary-color p-10 h-100">
								<div class="elementHistoy pl-0">
									<span class="buttonType">{{$t('1_day_range')}}</span>
								</div>
								<ul class="sliderange mb-3">
									<li class="w-100">
										<div class="d-flex justify-content-between align-items-center">
											<p class="f-12">{{parseFloat(parseFloat(oneDayData.low || 0).toFixed(5)) || '-'}}</p>
											<p class="f-12">{{parseFloat(parseFloat(oneDayData.high || 0).toFixed(5)) || '-'}}</p>
										</div>
										<div class="slidecontainer d-flex align-items-center">
										 <p class="f-14 red">{{$t('l') }} </p>
										  <input type="range" min="1" max="100" value="50" class="slider" id="myRange" disabled>
										  <p class="f-14 green">{{$t('h') }} </p>
										</div>
									</li>
								</ul>
								<p class="f-14 mb-3">{{$t('52_day_range')}}</p>
								<ul class="sliderange">
									<li class="w-100">
										<div class="d-flex justify-content-between align-items-center">
											<p class="f-12">{{parseFloat(parseFloat(prevYearData.low || 0).toFixed(5)) || '-'}}</p>
											<p class="f-12">{{parseFloat(parseFloat(prevYearData.high || 0).toFixed(5)) || '-'}}</p>
										</div>
										<div class="slidecontainer d-flex align-items-center">
										 	<p class="f-14 red">{{$t('l') }} </p>
										  		<input type="range" min="1" max="100" value="50" class="slider" id="myRange" disabled>
										  	<p class="f-14 green">{{$t('h') }} </p>
										</div>
									</li>
								</ul>
							</div>
							<div class="secondary-color p-10 h-100">
								<div class="d-flex align-items-center justify-content-between">
									<div class="elementHistoy pl-0">
										<span class="buttonType">{{$t('technicals') }} </span>
									</div>
									<ul class="technicals d-flex align-items-center">
										<li :class="(techInterval == '1D')?'active':' '">
											<a @click="changeTectInterval('1D')" class="sm" href="#">{{$t('daily')}}</a>
										</li>
										<li :class="(techInterval == '1W')?'active':' '">
											<a @click="changeTectInterval('1W')" class="sm" href="#">{{$t('weekly')}}</a>
										</li>
										<li :class="(techInterval == '1M')?'active':' '">
											<a @click="changeTectInterval('1M')" class="sm" href="#">{{$t('monthly')}}</a>
										</li>
									</ul>
								</div>
								<div class="mv-over d-flex align-items-center justify-content-between">
									<ul class="arge">
										<li class="d-flex align-items-center justify-content-between">
											<p class="sm">{{$t('moving_averages')}}</p>
											<p class="f-12" :class="getMAClass">{{getMA || '-'}}</p>
										</li>
										<li class="d-flex align-items-center justify-content-between">
											<p class="sm">{{$t('technical_indicators')}}</p>
											<p class="f-12" :class="getTecIndcClass">{{getTecIndc || '-'}}</p>
										</li>
										<!-- <li class="d-flex align-items-center justify-content-between">
											<p class="sm">Moving Average Crossovers</p>
											<p class="f-12 green">Bullish</p>
										</li> -->
									</ul>
									<!-- <div class="gPrt text-center">
										<p class="sm mb-1">Technical Rating</p>
										<a class="btn appButton d-flex align-items-center greenBG justify-content-center pointer-none" href="#">
											<feather size="12px" type="trending-up" class="mr-1"></feather> Very Bullish </a>
									</div> -->
								</div>
							</div>
						</div>
						<div class="content-tab list overView scrollbar" v-if="scriptType == 'List Property'">
							<div class="secondary-color p-10 h-100 listSpreads">
								<ul class="swapSort" v-if="instruments[loadChart]">
									<li>{{$t('spread')}}  <span>{{ (instruments[loadChart].other || {}).Spread || '-'}}</span></li>
									<li>{{$t('digits')}} <span>{{(((instruments[loadChart].other || {}).Tick_Size || '').split('.')[1] || '').length}}</span></li>
									<!-- <li>Stop Levels: <span>10</span></li> -->
									<li>{{$t('contact_size')}}  <span>{{(instruments[loadChart].other || {}).Contract_Size || '-'}}</span></li>
									<li>{{$t('type')}}  <span>{{(instruments[loadChart].other || {}).type=='INDICIES'?'INDICES':((instruments[loadChart].other || {}).type || '-')}}</span></li>
									<li>{{$t('min_tick_size')}}  <span>{{(instruments[loadChart].other || {}).Tick_Size || '-'}}</span></li>
									<li>{{$t('min_lot')}}  <span>{{(instruments[loadChart].other || {}).Min_Trade_Size || '-'}}</span></li>
									<li>{{$t('max_lot')}}  <span>{{(instruments[loadChart].other || {}).Max_Trade_Size || '-'}}</span></li>
									<li>{{$t('pip_size')}}  <span>{{(instruments[loadChart].other || {}).pip_size || '-'}}</span></li>
									<li>{{$t('stop_limit_levels')}} <span>{{(instruments[loadChart].other || {}).condition_distance || '-'}}</span></li>
									<li>{{$t('base_currency')}}  <span>{{(instruments[loadChart].other || {}).base_currency || '-'}}</span></li>Value
									<li>{{$t('swap_type')}}  <span>{{(instruments[loadChart].other || {}).swap_type || '-'}}</span></li>
									<li>{{$t('swap_long')}}  <span>{{(instruments[loadChart].other || {}).Long_Swaps || '-'}}</span></li>
									<li>{{$t('swap_short')}} <span>{{(instruments[loadChart].other || {}).Short_Swaps || '-'}}</span></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="orderTab-bottom">
					<p class="tableTitle f-14 mb-0">{{$t('pivot_table')}}</p>
					<div class="responsiveTable scrollbar bottomTable">
						<!-- {{ pivotData }} -->
						<table class="table table-hover text-center last-child">
							<thead>
								<tr>
									<th>{{$t('type')}}</th>
									<th>{{$t('pp')}}</th>
									<th>{{$t('s1')}}</th>
									<th>{{$t('s2')}}</th>
									<th>{{$t('s3')}}</th>
									<th>{{$t('r1')}}</th>
									<th>{{$t('r2')}}</th>
									<th>{{$t('r3')}}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item,key in pivotData">
									<td class="text-capitalize">{{key}}</td>
									<td>{{ Number(item['PP'] || 0).toFixed(contractSize.length-1) }}</td>
									<td>{{ Number(item['S1'] || 0).toFixed(contractSize.length-1) }}</td>
									<td>{{ Number(item['S2'] || 0).toFixed(contractSize.length-1) }}</td>
									<td>{{ Number(item['S3'] || 0).toFixed(contractSize.length-1) }}</td>
									<td>{{ Number(item['R1'] || 0).toFixed(contractSize.length-1) }}</td>
									<td>{{ Number(item['R2'] || 0).toFixed(contractSize.length-1) }}</td>
									<td>{{ Number(item['R3'] || 0).toFixed(contractSize.length-1) }}</td>
								</tr>
							</tbody>
						</table>
					</div>   
				</div>
			</div>
			<div class="rightSide-section withoutPOP@ leftShow-bar-alert@">
				<!-- <app-buyselltabing> </app-buyselltabing> -->
				<div class="leftShow-bar h-initial w-100 h-calc310">
					<app-news-section></app-news-section>
				</div>
			</div>
				
	
		</div>
	</div>
	</template>
	
	<script>
	import buy_sell_tabing from './home-elements/buy-sell-tabing'
	// import chart_section from './home-elements/chart-section'
	import chart_iq from "../shared/chart-iq";
	import trading_view from "../shared/trading-view";
	import newsSection from './home-elements/news-section'
	import news_popup from '../shared/news-popup'
	import app_watchlist from '../shared/app-watchlist'
	import { Const } from '@/plugins/vue-provider-cache/const.mod'
	import { commonAllmixins } from '@/plugins/commonAll'
	const product_type = process.env.product_type;
	export default {
		name: 'scrip-detail',
		mixins: [commonAllmixins],
		data() {
			return {
				currencyType: 'ALL',
				chartType: 'USD-BTC',
				order: 'open',
				rightTabs: 'watchlist',
				newsType:false,
				accordian: '1',
				buySellType: 'buy',
				indexNo: '',
				page : '1',
				buySell: '',
				scriptType: 'All',
				tradeBuySell: false,
				setUpFxaccount: false,
				"loadChart" : "EURUSD"+product_type,
				mn:'EURUSD'+product_type,
				chartKeys: { 'key':"EURUSD"+product_type, 'mn':"EURUSD"+product_type},
				oneDayData: {},
				prevYearData: {},
				assetType:{
					'currencies':'Forex',
					'Commodities':'Commodities',
					'INDICIES':'Indices'
				},
				techInterval:'1D'
			}
		},
		watch:{
			loadChart(val){
				let _that = this;
				let price_detail = _that.instruments || {};
				if(Object.keys(price_detail).length == 0){
					let interval = setInterval(()=>{
						try{
							if(_that.$store.getters[Const.GET_PROVIDERS]['priceFeed']){
								clearInterval(interval);
								_that.getOneDayData();
								_that.getPrevYearData();
							}
						}catch(e){ }
					},500)
				}else{
					this.getOneDayData()
					this.getPrevYearData()
				}
				this.techInterval = '1D'
				this.callTechAnalysis()
			},
			chartKeys(value){
				this.mn = value.mn
				this.loadChart = value.key
			}
		},
		components:{
			chartIq: chart_iq,
			tradingView: trading_view,
			// appChartsecssion: chart_section,
			AppNewsSection: newsSection,
			AppBuyselltabing: buy_sell_tabing,
			appNewspopup : news_popup,
			appWatchlist:app_watchlist,
		},
		methods:{
			changeTectInterval(val){
				if(this.techInterval != val){
					this.techInterval = val
					this.callTechAnalysis()
				}
			},
			cugrrentClose(){
				try{
					return this.instruments[this.loadChart].B
				}
				catch(e){ return ''; }
			},
			lastClose(){
				try{
					return this.instruments[this.loadChart].other.closepx
				}
				catch(e){ return ''; }
			},
			AddRemIndex(value){
				if(this.indexNo == value){
					this.indexNo = ''
				}else{
					this.indexNo = value
				}
			},
			formatDate(data) {
				let now = new Date(data);
				let year = "" + now.getFullYear();
				let month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
				let day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
				let hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
				let minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
				return year + month + day + hour + minute;
			},
			getOneDayData(){
				let link = this.$env_var.LIVE_CHART_URL
				if(this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].settings.patchers.SecurityMasterPatcher.DW_HOST){
                    link = this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].settings.patchers.SecurityMasterPatcher.DW_HOST+"/api/provider/charting";
                }
				let sendData = {
					'globalParams':{
						"isin" : this.mn ,
						 "startdate" : this.formatDate(Date.now()) ,
						"enddate" : '',
						"interval" : '1day'
					},
					'localParams':{'parameter':this, 'link':link, type:'day'}
				}
				this._runGetChartData(sendData)
			},
			getPrevYearData(){
				var prev = new Date();
				prev.setFullYear(prev.getFullYear() - 1);
				let onePev = new Date(prev);
				onePev.setDate(onePev.getDate() - 1);
				let link = this.$env_var.LIVE_CHART_URL
				if(this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].settings.patchers.SecurityMasterPatcher.DW_HOST){
                    link = this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].settings.patchers.SecurityMasterPatcher.DW_HOST+"/api/provider/charting";
                }
				let sendData = {
					'globalParams':{
						"isin" : this.mn ,
						 "startdate" : this.formatDate(onePev),
						"enddate" : this.formatDate(new Date()),
						"interval" : '1month',
						"count": 12
					},
					'localParams':{'parameter':this, 'link':link , type: 'year' }
				}
				this._runGetChartData(sendData)
			},
			callTechAnalysis(){
				let sendData = {
					'globalParams':{
						"market" : this.loadChart ,
						"interval" : this.techInterval,
					},
					'localParams':{'parameter':this }
				}
				this._runGetTechnicalAnalysis(sendData)
				this.callPivotData()
			},
			callPivotData(){
				let sendData = {
					'globalParams':{
						"market" : this.loadChart ,
						"interval" : this.techInterval,
						"level_type" : ""//classic
					},
					'localParams':{'parameter':this }
				}
				this._runGetPivotData(sendData)
			}
		},
		computed:{
			getMA(){
				if(this.technicalAnalysis.length){
					let data = this.technicalAnalysis.filter(val=>val.ind == "MA")[0]
					if(data && ('Value' in data || 'value' in data)){
						let value = parseFloat(data.Value || data.value);
						return (value >= 4)?'STRONG BULLISH'
								:(value >= 2)?'BULLISH'
								:(value < 2 && value > -2)?'NEUTRAL'
								:(value <= -4)?'STRONG BEARISH'
								:(value <= -2)?'BEARISH':''
					}else{
						return ''
					}
				}else{
					return ''
				}
			},
			getMAClass(){
				if(this.technicalAnalysis.length){
					let data = this.technicalAnalysis.filter(val=>val.ind == "MA")[0]
					if(data && ('Value' in data || 'value' in data)){
						let value = parseFloat(data.Value || data.value);
						return (value >= 4)?'green'
								:(value >= 2)?'green'
								:(value < 2 && value > -2)?'text-warning'
								:(value <= -4)?'red'
								:(value <= -2)?'red':''
					}else{
						return ''
					}
				}else{
					return ''
				}
			},
			getTecIndc() {
				if (!this.technicalAnalysis.length) return '';

				let value = this.technicalAnalysis.reduce((sum, val) => {
					let num = parseFloat(val.Value || val.value);
					return sum + (isNaN(num) ? 0 : num); // ignore invalid numbers
				}, 0);

				if (value > 9) return 'STRONG BULLISH TREND';
				if (value >= 5) return 'BULLISH TREND';
				if (value > -5) return 'NEUTRAL TREND';
				if (value >= -9) return 'BEARISH TREND';
				return 'STRONG BEARISH TREND';
			},
			getTecIndcClass(){
				if (!this.technicalAnalysis.length) return '';

				let value = this.technicalAnalysis.reduce((sum, val) => {
					let num = parseFloat(val.Value || val.value);
					return sum + (isNaN(num) ? 0 : num); // ignore invalid numbers
				}, 0);

				if (value > 9) return 'green';
				if (value >= 5) return 'green';
				if (value > -5) return 'text-warning';
				if (value >= -9) return 'red';
				return 'red';
			},
			contractSize(){
				return (this.currencyPairs.find(v=> v.mn == this.loadChart) || {}).market_ContractSize || 10000;
			},
			instruments() {
				try {                    
					this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
					return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
				} catch (ex) {                
					return {}
				}
			}
		},
		created(){
			if(this.$route.query.market && this.loadChart != this.$route.query.market){
				try{
					this.mn =this.currencyPairs.filter(val=>val.isinid.includes(this.$route.query.market))[0].mn
					this.loadChart = this.$route.query.market
				}catch(e){}
			}else{
				this.callTechAnalysis()
				let _that = this
				let interval = setInterval(()=>{
					let price_detail = _that.instruments || {};
					if(_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'] && Object.keys(price_detail).length > 0){
						try{
							if(_that.$store.getters[Const.GET_PROVIDERS]['priceFeed']){
								_that.getOneDayData();
								_that.getPrevYearData();
								clearInterval(interval);
							}
						}catch(e){ }
					}
				},500)
			}
		},
		mounted() {
			const _that = this
			$(document).on("click", function(event){
				if(!$(event.target).closest('.openBuySell').length){
					_that.buySell = ''
					_that.tradeBuySell = false
				}
			});
		}
		
	}
	</script>
	


// WEBPACK FOOTER //
// src/components/website/user/scrip-detail.vue